"use client"

import { PowerOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PowerOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PowerOffIcon = component(Icon)({ as: PowerOff })
